export default __webpack_public_path__ + "static/media/logo-md-2048w.55208dbc.avif";